import { createSlice } from "@reduxjs/toolkit";

const initialCourseSubject = {
  subject: "",
  code: "",
  explanation: ""
};

const initialCourseSubjectsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  courseSubject: initialCourseSubject
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const courseSubjectSlice = createSlice({
  name: "courseSubjects",
  initialState: initialCourseSubjectsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCourseSubjects
    courseSubjectsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entity, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;      
      state.course = entity && entity.course;
    },
    //getCourseSubject
    courseSubjectFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.courseSubject = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanCourseSubjectsState
    courseSubjectsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
      state.courseSubject = initialCourseSubject;
    }
  }
});